import { createContext, Dispatch, SetStateAction } from 'react';
import { IProject, defaultProjectBase } from '../../../interfaces/project.interface';

const NewProjectContext = createContext<[IProject, Dispatch<SetStateAction<IProject>>]>([
	defaultProjectBase,
	() => {},
]);

export default NewProjectContext;
